import { createQueryKeys } from "@lukemorales/query-key-factory";

import type { GetVoucherListRequestDto } from "@/modules/voucher/dtos/get-voucher-list-request-dto";

export const VoucherQueryKeys = createQueryKeys("voucher", {
  getVoucherList: ({ q, page, limit, sort }: GetVoucherListRequestDto) => [
    q,
    page,
    limit,
    sort
  ],
  getVoucherDetail: (voucherId: number) => [voucherId]
});
